<app-stepper
  [title]="stepperTitle | translate"
  [currentStep]="base.currentStep"
  [totalSteps]="3"
  [showButtons]="base.currentStep !== 1"
  [showStepper]="showStepper"
  [showInfoIcon]="base.showInfoIcon"
  [backDisabled]="base.backDisabled"
  [nextDisabled]="base.nextDisabled"
  [backButtonText]="base.backButtonText"
  [nextButtonText]="base.nextButtonText"
  [isCalendarView]="base.isCalendarView"
  (navButtonClicked)="updateStep($event)"
  (infoIconClicked)="onInfoIconClicked()"
  #stepper
  *ngIf="!base.serverError && !base.sectionMaintenance">
  <ng-container [ngSwitch]="base.currentStep">
    <app-first-step
      [seasons]="base.seasons"
      [proposals]="base.proposals"
      [canEdit]="base.hasEditPermission"
      [isMomoUser]="base.isMomoUser"
      (cardClicked)="setSeason($event)"
      (actionClicked)="editProposal($event, false)"
      (addProposalsClicked)="addProposals($event)"
      (observationsChanged)="base.editObservations($event)"
      *ngSwitchCase="1"></app-first-step>
    <app-mot-criteria-step
      [criteria]="base.criteria"
      [selectedSeason]="base.selectedSeason"
      (alternationGuideClicked)="updateStep(true)"
      *ngSwitchCase="2"></app-mot-criteria-step>
    <ng-container *ngSwitchCase="3">
      <app-mot-calendar-step
        [calendar]="base.seasonCalendar"
        [initialSlots]="base.initialSlots"
        [selectedSeason]="base.selectedSeason"
        [notSelectedSeason]="base.notSelectedSeason"
        [emptySlots]="base.errorMsg"
        (slotClicked)="setSlots($event)"
        *ngIf="!base.showResumeView else resume"></app-mot-calendar-step>
      <ng-template #resume>
        <app-resume [selectedSeason]="base.selectedSeason" [slots]="base.slots" [proposal]="base.seasonProposal">
        </app-resume>
      </ng-template>
    </ng-container>
  </ng-container>
</app-stepper>
